import { Injectable, DOCUMENT, inject, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly isDarkMode = new BehaviorSubject<boolean>(false);
  readonly isDarkMode$ = this.isDarkMode.asObservable();
  readonly isDarkSignal = signal<boolean>(false);

  constructor() {
    let initialDark = false;
    try {
      const saved = localStorage.getItem('workforce-theme');
      if (saved) {
        initialDark = saved === 'dark';
      }
    } catch {}
    this.isDarkMode.next(initialDark);
    this.isDarkSignal.set(initialDark);
    this.updateBodyThemeClass();
  }

  toggleTheme(): void {
    this.setTheme(!this.isDarkMode.value);
  }

  setTheme(isDark: boolean): void {
    this.isDarkMode.next(isDark);
    this.isDarkSignal.set(isDark);
    try {
      localStorage.setItem('workforce-theme', isDark ? 'dark' : 'light');
    } catch {}
    this.updateBodyThemeClass();
  }

  get currentIsDark(): boolean {
    return this.isDarkMode.value;
  }

  private updateBodyThemeClass(): void {
    const isDark = this.isDarkMode.value;
    const body = this.document.body;
    body.classList.remove('dark', 'light');
    body.classList.add(isDark ? 'dark' : 'light');

    const rootElement = this.document.documentElement;
    rootElement.setAttribute('theme', isDark ? 'dark' : 'light');
    rootElement.setAttribute('data-theme', isDark ? 'dark' : 'light');

    rootElement.style.removeProperty('--theme-background');
    rootElement.style.removeProperty('--theme-color');

    if (isDark) {
      rootElement.style.setProperty('--theme-background', '#090a0f');
      rootElement.style.setProperty('--theme-color', '#ffffff');
    } else {
      rootElement.style.setProperty('--theme-background', '#F7F5F2');
      rootElement.style.setProperty('--theme-color', '#121212');
    }
  }
}
